import { render, staticRenderFns } from "./whatsappMe.vue?vue&type=template&id=04dc520c&scoped=true"
import script from "./whatsappMe.vue?vue&type=script&lang=js"
export * from "./whatsappMe.vue?vue&type=script&lang=js"
import style0 from "./whatsappMe.vue?vue&type=style&index=0&id=04dc520c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dc520c",
  null
  
)

export default component.exports